/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Option_Aria_LabelInputs */

const en_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select segmentation option`)
};

const fr_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionner l'option de segmentation`)
};

const de_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentierungsoption auswählen`)
};

const it_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona l'opzione di segmentazione`)
};

const ru_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите вариант сегментации`)
};

const es_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccionar la opción de segmentación`)
};

const zh_cn2_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择分段选项`)
};

const ja_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメンテーションオプションを選択`)
};

const hi_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन विकल्प चुनें`)
};

const pt_pt2_segment_event_group_option_aria_label = /** @type {(inputs: Segment_Event_Group_Option_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione a opção de segmentação`)
};

/**
* | output |
* | --- |
* | "Select segmentation option" |
*
* @param {Segment_Event_Group_Option_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_option_aria_label = /** @type {((inputs?: Segment_Event_Group_Option_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Option_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_option_aria_label(inputs)
	if (locale === "de") return de_segment_event_group_option_aria_label(inputs)
	if (locale === "it") return it_segment_event_group_option_aria_label(inputs)
	if (locale === "ru") return ru_segment_event_group_option_aria_label(inputs)
	if (locale === "es") return es_segment_event_group_option_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_option_aria_label(inputs)
	if (locale === "ja") return ja_segment_event_group_option_aria_label(inputs)
	if (locale === "hi") return hi_segment_event_group_option_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_option_aria_label(inputs)
	return en_segment_event_group_option_aria_label(inputs)
});